<template>
</template>

<script>
export default {
  created() {
    this.loginClick();
  },
  methods: {
    loginClick() {
      this.$router.push({
        path:"/login/FD6C8EC28FA87153/A3FFBEBFDB713E27" +"?"+"loginType="+this.$route.query.loginType,
        query: {}
      });
      
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-tabs .ivu-tabs-bar {
  border-bottom-width: 0px !important;
  .ivu-tabs-nav .ivu-tabs-tab {
    height: 40px;
    background: #f7f9fc;
    border-radius: 5px;
    font-size: 16px;
  }
  .ivu-tabs-ink-bar {
    height: 0;
  }
  .ivu-tabs-nav .ivu-tabs-tab-active {
    background-color: #f1f2fd;
    color: #4ea397;
  }
  .ivu-tabs-nav-wrap {
    display: flex;
    justify-content: center;
  }
}

.homeMoreBtn {
  padding: 0 20px;
  border-radius: 5px;
  background-color: #f1f2fd;
  color: #4ea397;
  display: table;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  margin-top: 40px;
}
.home {
  width: 100%;
  background: #ffffff;
  .homeHeader {
    width: 100%;
    height: 64px;
    background: linear-gradient(to right, #4ea397, #7bd9a5);
    border-bottom: 1px solid #7bd9a5;
    .homeBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      color: #ffffff;
      font-size: 16px;
    }
    .homeTitle {
      font-size: 16px;
      font-weight: bold;
    }
    .homeLogin {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        margin-left: 15px;
      }
    }
  }
  .homeConter {
    .homeBanner {
      max-height: 713px;
      width: 100%;
      //  background: linear-gradient(to right,#4ea397,#7bd9a5);
      img {
        width: 100%;
        max-height: 713px;
      }
      .bannerMain {
        position: relative;
        .bannerText {
          position: absolute;
          top: 80px;
          left: 10%;
          color: #ffffff;
        }
      }
    }
    .homePlan {
      padding: 55px 0;
      box-sizing: border-box;
      .planTitle {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
      }
      .planMain {
        margin-top: 40px;
        .planBox {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .planText {
            width: 50%;
            box-sizing: border-box;
            padding: 40px;
            h4 {
              font-size: 28px;
              color: #000000;
              margin: 20px 0;
            }
            span {
              font-size: 16px;
              line-height: 36px;
            }
          }
          .planImg {
            width: 50%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .homeChoice {
      background: url("../assets/home/homeChoiceBg.png");
      background-size: 100% 100%;
      padding: 55px 0;
      .choiceTitle {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
      }
      .choiceList {
        display: flex;
        flex-wrap: wrap;
        width: 80%;
        margin: 0 auto;
        .choiceItem {
          border: 2px solid #f1f2fd;
          border-radius: 8px;
          width: 47%;
          height: 250px;
          background: #ffffff;
          margin-top: 50px;
          margin-right: 6%;
          position: relative;
          padding: 40px;
          box-sizing: border-box;
          h4 {
            font-size: 22px;
            color: #000000;
            margin-bottom: 20px;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          span {
            line-height: 28px;
            font-size: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
          }
          img {
            width: 54px;
            height: 40px;
            position: absolute;
            top: 20px;
            left: 20px;
          }
        }
        .choiceItem:nth-child(even) {
          margin-right: 0;
        }
      }
    }
    .homeBusiness {
      padding: 55px 0;
      box-sizing: border-box;
      .businessTitle {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
      }
      .businessMain {
        margin: 60px 0;
        img {
          width: 100%;
        }
      }
    }
  }
}
.homeBox {
  width: 88%;
  margin: 0 auto;
}
.homeFooter {
  width: 100%;
  .footerLine {
    width: 100%;
    height: 10px;
    background: linear-gradient(to right, #7f8bef, #a877f8, #c769fe);
  }
  .footerMain {
    width: 100%;
    background-color: #3e4652;
    .footerBox {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      height: 110px;
      color: #ffffff;
      align-items: center;
      .footerList {
        display: flex;
        flex-wrap: wrap;
        a {
          padding: 0 20px;
          color: #ffffff;
          display: block;
        }
      }
    }
  }
  .footerCopyright {
    border-top: 1px solid #777777;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #3e4652;
    color: #ffffff;
  }
}
@media screen and (max-width: 800px) {
  .planText {
    width: 100% !important;
  }
  .planImg {
    width: 100% !important;
  }
  .choiceItem {
    width: 100% !important;
    margin-right: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginShow.vue